import React, {
  useEffect,
  useState,
  forwardRef,
  useImperativeHandle,
} from "react";
import {
  Table,
  Button,
  Modal,
  Form,
  Input,
  Radio,
  DatePicker,
  Select,
  Row,
  Col,
} from "antd";
import "antd/dist/antd.css";
import GetHost from "../lib/GetHost";
import pr from "../util/pr";
import axios from "axios";
import moment from "moment";
import locale from "antd/es/date-picker/locale/ko_KR";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import CenterSelect from "../lib/CenterSelect";
import { useSelector, useDispatch } from "react-redux";
import LoginCheck from "../util/LoginCheck";
import DecodeData from "../util/DecodeData";

const { Option } = Select;
const { confirm } = Modal;

const { RangePicker } = DatePicker;

const token = localStorage.getItem("refresh_token"); // 토큰

// 폼데이타 기본값
let formData = {
  mcd: "",
  enroll_sdate: moment().format("YYYY-MM-DD"),
  enroll_edate: moment().format("YYYY-MM-DD"),
  pt_type: "PT",
  use_count: 0,
  total_count: 1,
  state: "Y",
};

function PtCouponAdd(props) {
  const { seq, visible, onHideModal, onReload, onShowMemberModal, addSearch } =
    props;

  const [form] = Form.useForm();
  formData.mcd = addSearch.mcd;

  // 로그인
  const data = useSelector((state) => state.data);
  const dispatch = useDispatch();
  const getLogin = async () => {
    let result = await LoginCheck(data.url);
    if (result === "Y") {
      const decodeResult = await DecodeData(data.url);
      dispatch({ type: "SET", name: "CID", value: decodeResult.cid });
      dispatch({ type: "SET", name: "LEVEL", value: decodeResult.level });
    }
    if (data.cid !== "root") {
      formData.cid = data.cid;
    }
  };

  useEffect(() => {
    if (data.url !== "") {
      getLogin();
    }
  }, [data.url]);

  const handleCancel = () => {
    onHideModal();
  };

  const onFinish = async (value) => {};

  const onCenterChange = (value) => {
    formData.cid = value;
  };

  const onRangeChange = (value) => {
    formData.enroll_sdate = moment(value[0]).format("YYYY-MM-DD");
    formData.enroll_edate = moment(value[1]).format("YYYY-MM-DD");
  };

  const onPtTypeChange = (value) => {
    formData.pt_type = value;
  };

  const onUseCountChange = (event) => {
    formData.use_count = event.target.value;
  };

  const onTotalCountChange = (event) => {
    formData.total_count = event.target.value;
  };

  const onStateChange = (event) => {
    formData.state = event.target.value;
  };

  const onConfirm = async () => {  
    
    const result = await axios.post(
      GetHost() + "/gympass_admin/pt_coupon_add",
      {
        cid:formData.cid,
        token: token,
        mcd: formData.mcd,
        pt_type: formData.pt_type,
        enroll_sdate: formData.enroll_sdate,
        enroll_edate: formData.enroll_edate,
        use_count: formData.use_count,
        total_count: formData.total_count,
        state: formData.state,
      }
    );
    if(result.data.ret==='N') {
      Modal.error({
        title:"ERROR",
        content: result.data.msg,
      })
    }
    else {
      onReload();
    }
  };

  return (
    <Form form={form} onFinish={onFinish}>
      <Modal
        onCancel={handleCancel}
        title="PT/GX 쿠폰"
        visible={visible}
        footer={[
          <Button key="1" type="primary" onClick={onConfirm}>
            등록완료
          </Button>,
        ]}
      >
        {data.cid === "root" && (
          <Form.Item labelCol={{ span: 4 }} label="센터명">
            <CenterSelect width="200" onCenterChange={onCenterChange} />
          </Form.Item>
        )}

        <Row>
          <Col span={4} style={{ textAlign: "right", paddingRight: 7 }}>
            고객명:
          </Col>
          <Col>
            <Input
              value={addSearch.mb_name}
              readOnly="readonly"
              style={{ width: 120, background: "#CCCCCC" }}
            ></Input>
          </Col>
          <Col>
            <Form.Item style={{ paddingLeft: 10 }}>
              <Button type="primary" onClick={() => onShowMemberModal()}>
                찾기
              </Button>
            </Form.Item>
          </Col>
        </Row>

        <Form.Item
          name="pt_type"
          labelCol={{ span: 4 }}
          label="쿠폰종류"
          initialValue={formData.pt_type}
        >
          <Select style={{ width: 100 }} onChange={onPtTypeChange}>
            <Option value="PT">PT</Option>
            <Option value="GX">GX</Option>
          </Select>
        </Form.Item>

        <Form.Item
          name="enroll_date"
          label="유효기간"
          labelCol={{ span: 4 }}
          initialValue={[moment(), moment()]}
        >
          <RangePicker locale={locale} onChange={onRangeChange} />
        </Form.Item>

        <Form.Item label="수량" labelCol={{ span: 4 }}>
          <Input.Group compact>
            <Form.Item
              name="use_count"
              noStyle
              initialValue={formData.use_count}
            >
              <Input
                style={{ width: "20%" }}
                placeholder="사용"
                autoComplete="off"
                onChange={onUseCountChange}
              />
            </Form.Item>
            <Form.Item
              name="total_count"
              noStyle
              autoComplete="off"
              initialValue={formData.total_count}
            >
              <Input
                style={{ width: "20%" }}
                placeholder="보유"
                autoComplete="off"
                onChange={onTotalCountChange}
              />
            </Form.Item>
          </Input.Group>
        </Form.Item>

        <Form.Item
          labelCol={{ span: 4 }}
          name="state"
          label="상태"
          initialValue={formData.state}
        >
          <Radio.Group onChange={onStateChange}>
            <Radio value="Y">예</Radio>
            <Radio value="N">아니오</Radio>
          </Radio.Group>
        </Form.Item>
      </Modal>
    </Form>
  );
}

export default PtCouponAdd;
